/**
 * The single seam through which Intl.* calls become locale-aware.
 *
 * Any module that formats a number, currency or date for display should get
 * its locale tag from here rather than hardcoding 'de-DE' — see
 * utils/numberFormat.js and utils/berlinDate.js for the two current consumers.
 */

import i18n from './index';
import { DEFAULT_LANGUAGE, INTL_LOCALE_BY_LANGUAGE } from './config';

/**
 * Current BCP 47 locale tag for Intl.NumberFormat / Intl.DateTimeFormat.
 *
 * Reads i18n.resolvedLanguage INSIDE the function body on purpose: evaluating
 * it at module scope would freeze whatever language happened to be active at
 * import time, and every later language switch would be ignored by callers
 * that captured the value once.
 *
 * Note this only makes the *formatting* follow the language. Getting a
 * component to re-render after a switch is the caller's job — see the
 * consequence noted in i18n/index.js.
 */
export const getActiveIntlLocale = () =>
  INTL_LOCALE_BY_LANGUAGE[i18n.resolvedLanguage] ||
  INTL_LOCALE_BY_LANGUAGE[DEFAULT_LANGUAGE];
